import React from 'react';

const MDCCheckbox = ({
  label,
  name,
  id,
  checked = false,
  onChange,
  className = '',
  value = '1',
  ...props
}) => {
  return (
    <div className="pm-flex-col">
      <div className="mdc-form-field">
        <div
          id="mdc-js-checkbox"
          className="mdc-checkbox"
          data-mdc-auto-init="MDCCheckbox"
        >
          <input
            type="checkbox"
            name={name}
            id={id}
            value={value}
            className={`mdc-checkbox__native-control ${className}`}
            checked={checked}
            onChange={onChange}
            {...props}
          />
          <div className="mdc-checkbox__background">
            <svg className="mdc-checkbox__checkmark" viewBox="0 0 24 24">
              <path
                className="mdc-checkbox__checkmark-path"
                fill="none"
                stroke="white"
                d="M1.73,12.91 8.1,19.28 22.79,4.59"
              />
            </svg>
            <div className="mdc-checkbox__mixedmark"></div>
          </div>
        </div>
        <label htmlFor={id}>{label}</label>
      </div>
    </div>
  );
};

export default MDCCheckbox;
